import React from 'react'
import SubTitlePageProps from './sub-title-page.interface'
import { SubTitlePageWrapper } from './sub-title-page.styles'

function SubTitlePage({ subtitlePage }: SubTitlePageProps) {
	return <SubTitlePageWrapper>{subtitlePage}</SubTitlePageWrapper>
}

export default SubTitlePage
